import axios from 'axios';
import AppConfig from "../../../../../AppConfig";

let URL = AppConfig.HOST_API() + 'ekipaPoj/';

export default {

    getEkipaPoj() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getPojWEkipie(id) {
        return axios({
            method: 'get',
            url: URL + 'ekipa/' + id,
        });
    },

    addEkipaPoj(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editEkipaPoj(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteEkipaPoj(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/polaczenieEkipIPojazdow/PolaczenieEkipIPojazdowService.js